import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="comment"
export default class extends Controller {
  static targets = ['actions']
  static values = { commentUserId: Number }

  connect() {
    const commentUserId = parseInt(this.commentUserIdValue)
    const currentUserId = parseInt(document.body.dataset.currentUserId)

    if (currentUserId === commentUserId) {
      this.actionsTarget.classList.remove('hide')
    }
  }
}
